import { aggregateDealNotifications } from '../helpers';
export default function updateDealNotifications(_ref) {
  let {
    types
  } = _ref;
  return payload => async dispatch => {
    const dealNotifications = aggregateDealNotifications(payload);
    dispatch({
      type: types.UPDATE_DEAL_NOTIFICATIONS,
      payload: {
        ...dealNotifications
      }
    });
  };
}